import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Link,
  Text,
  TextContainer,
} from './styles';

const ExpiredComponent = (props) => {
  /** props */
  const { onClick } = props;

  return (
    <Container>
      <TextContainer>
        <Text>Your session has expired.</Text>
        <Text>
          Head to the&nbsp;
          <Link onClick={onClick}>Browse Tests</Link>
          &nbsp;tab to see if there are any spots left.
        </Text>
      </TextContainer>
    </Container>
  );
};

ExpiredComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ExpiredComponent;
